import React, {useEffect, useRef, useState} from "react";
import createLightGallery from "../../../Common/services/createLightGallery";
import PropTypes from "prop-types";

const isDev = (process.env.NODE_ENV == 'development');

export default function ItemImageBox({product}) {
  const ref = useRef(null);
  const [gallery, setGallery] = useState(null);
  const [currentImage, setCurrentImage] = useState(null);

  function destroyGallery() {
    if (gallery?.destroy) {
      gallery.destroy();
    }
  }

  // calculate new image paths when product changes; this will also trigger the next effect.
  // (trying to do it all in one effect means the thing runs twice)
  useEffect(() => {
    if (!product || !product.images)
      return;

    // 2026-09 small are deprecated
    const {small = [], mid = [], large = []} = (product.images || {});
    const pic = (large && large[0]) || (mid && mid[0]) || (small && small[0]);

    setCurrentImage(pic);
  }, [product?.id]);

  useEffect(() => {
    if (!ref?.current || !currentImage)
      return;

    destroyGallery();

    let g = createLightGallery(ref.current);
    setGallery(g);

    return destroyGallery();
  }, [ref?.current, currentImage])


  // FIXME: this works only with the AAG legacy paths
  const imagePath = currentImage?.url || currentImage?.fullPath;
  const bigPath = imagePath && imagePath.replace("/sm/", "/lg/").replace("/md/", "/lg/");

  if (!currentImage) {
    return <div ref={ref}>{
      isDev && <div className="debug">ItemImageBox: no image for product {product.id}</div>
    }</div>;
  }

  // IMPORTANT: class "pic" is required to activate the gallery plugin
  return <div className="relative" ref={ref}>
    <a className="pic max-w-full w-full" href={bigPath}><img
      alt={product.name} src={imagePath}/>
      <div className="z-10 absolute -bottom-1 -right-1"><span
        className="text-2xl text-gray-500  fa-duotone fa-magnifying-glass"/></div>
    </a>
    {isDev && <div className="debug text-2xs">{JSON.stringify(currentImage, null, 2)}</div>}
  </div>
}

ItemImageBox.propTypes = {
  product: PropTypes.object.isRequired
}
